import React, { useState, useLayoutEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Grid, Paper, Typography, TextField } from "@material-ui/core";
import { MobXProviderContext } from "mobx-react";
import useStyles, { STGrid, STWrapper } from "./styles";
import { ThemeProvider } from "styled-components";
import { Values } from "@src/Tools/Values";
import STPageHeader from "@src/Components/Ui/STPageHeader";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { IManagementStore } from "@src/Stores/Management/types";
import { RouterStore } from "mobx-react-router";
import ForgotPasswordForm, { IForgotPasswordForm } from "./ForgotPasswordForm/ForgotPasswordForm";

function useStores() {
  return React.useContext(MobXProviderContext);
}

const handleSentToUserMail = async (values: IForgotPasswordForm, management: IManagementStore, setisSentMail: any) => {
  await management.sentResetLinkToUserMail(values.username, values.email);
  setisSentMail(true);
};

const handleGoToLogin = (routing: RouterStore) => {
  routing.history.push("/login");
  sessionStorage.removeItem("InvalidCredentials");
};

const ForgotPassword = (props: RouteComponentProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSentMail, setIsSentMail] = useState(false);
  const { values, routing, themes, management } = useStores();
  const classes = useStyles({});

  useLayoutEffect(() => {
    async function componentDidMount() {
      await themes.getCurrentTheme(values.themeTypes.Login);
      document.title = Values.getLocalizationValue("requestPasswordReset");
      setIsLoading(false);
    }
    if (isLoading) {
      componentDidMount();
    }
  }, []);

  if (isLoading) {
    return null;
  }
  return (
    <ThemeProvider theme={themes.login}>
      <STGrid
        id="forgot-password-page"
        container
        justify="center"
        direction="column"
        alignItems="center"
        className={classes.loginGrid}
        loginbackgroundlandscapeimageurl={themes.login.loginBackgroundLandscapeImageUrl}
        loginbackgroundportraitimageurl={themes.login.loginBackgroundPortraitImageUrl}
        styles={themes.login.css}
      >
        <img id="forgot-password-page-logo" className={classes.loginLogo} src={themes.login.loginLogoImageUrl} />
        <Paper elevation={2} className={classes.paperRoot} id="forgot-password-form">
          <STWrapper item>
            <Grid container justify="flex-start" style={{ width: "92%" }}>
              <STPageHeader>
                {Values.getLocalizationValue(isSentMail ? "passwordRequested" : "requestPasswordReset")}
              </STPageHeader>
            </Grid>
            {isSentMail ? (
              <>
                <Grid container justify="flex-start" style={{ width: "92%", paddingBottom: "24px" }}>
                  <Typography>{Values.getLocalizationValue("emailHowResetPassword")}</Typography>
                </Grid>
                <Grid container justify="center" style={{ display: "flex" }}>
                  <STButtonMargin
                    variant="contained"
                    color="default"
                    onClick={() => handleGoToLogin(routing)}
                    style={{ textTransform: "none" }}
                  >
                    {Values.getLocalizationValue("goToLogin")}
                  </STButtonMargin>
                </Grid>
              </>
            ) : (
              <>
                <Grid container justify="flex-start" style={{ width: "92%" }}>
                  {sessionStorage.getItem("InvalidCredentials") && (
                    <Typography>{`${Values.getLocalizationValue("username")}: ${sessionStorage.getItem(
                      "InvalidCredentials"
                    )}`}</Typography>
                  )}
                </Grid>
                <ForgotPasswordForm
                  onSubmit={(values: IEmailForm) => handleSentToUserMail(values, management, setIsSentMail)}
                >
                  <Grid container justify="flex-end" style={{ display: "flex", paddingTop: "20px" }}>
                    <STButtonMargin
                      variant="contained"
                      color="default"
                      onClick={() => handleGoToLogin(routing)}
                      style={{ textTransform: "none" }}
                    >
                      {Values.getLocalizationValue("goToLogin")}
                    </STButtonMargin>
                    <STButtonMargin variant="contained" color="primary" type="submit" style={{ textTransform: "none" }}>
                      {Values.getLocalizationValue("requestReset")}
                    </STButtonMargin>
                  </Grid>
                </ForgotPasswordForm>
              </>
            )}
          </STWrapper>
        </Paper>
      </STGrid>
    </ThemeProvider>
  );
};

export default ForgotPassword;
